/**
 * Created by Administrador on 16/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('classificationSsrCtrl', classificationSsrCtrl);

    classificationSsrCtrl.$inject = ['linkService', 'tabs','classifications'];
    function classificationSsrCtrl(linkService, tabs, classifications){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = classifications.data.page;
        vm.classifications = (classifications.data._embedded) ? classifications.data._embedded.ssrClassifications : [];
        vm.linkService = linkService;
    }
})();
